var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#prevArrow)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7335 7.26174C14.3781 6.91275 13.8041 6.91275 13.4487 7.26174L9.26651 11.3691C8.91116 11.7181 8.91116 12.2819 9.26651 12.6309L13.4487 16.7383C13.8041 17.0872 14.3781 17.0872 14.7335 16.7383C15.0888 16.3893 15.0888 15.8255 14.7335 15.4765L11.1982 11.9955L14.7335 8.52349C15.0888 8.1745 15.0797 7.60179 14.7335 7.26174Z",
    fill: props.color
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prevArrow"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prevArrow.2a3d47666e9398232ff4bc938f3efc2d.svg";
export { ForwardRef as ReactComponent };